import styled from '@emotion/styled';
import { Box, Heading } from '@rebass/emotion';
import { rem } from '@app/styles/theme/layout';

export const Title = styled(Heading)`
  text-transform: uppercase;
  margin-bottom: ${rem(16)};
`;

export const ContentBlockInnerHTML = styled(Box)`
  line-height: 1.8rem;
`;
